import * as React from 'react';
import { createTimer } from './timer.js';

var useDebounce = function useDebounce(method, delay) {
  var timeout = React.useRef(null);
  React.useEffect(function () {
    return function () {
      var _timeout$current;
      (_timeout$current = timeout.current) === null || _timeout$current === void 0 || _timeout$current.destroy();
    };
  }, [timeout]);
  return function () {
    var _timeout$current2;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    (_timeout$current2 = timeout.current) === null || _timeout$current2 === void 0 || _timeout$current2.destroy();
    timeout.current = createTimer({
      callback: function callback() {
        return method.apply(void 0, args);
      },
      delay: delay
    });
  };
};
var createDebouncedFunction = function createDebouncedFunction(method, delay) {
  var timeout = null;
  return function () {
    var _timeout;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    (_timeout = timeout) === null || _timeout === void 0 || _timeout.destroy();
    timeout = createTimer({
      callback: function callback() {
        return method.apply(void 0, args);
      },
      delay: delay
    });
  };
};

export { createDebouncedFunction, useDebounce };
//# sourceMappingURL=useDebounce.js.map
